import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSafariComponent } from './simple-icons-safari.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSafariComponent ],
    exports:      [ SimpleIconsSafariComponent ],
    bootstrap:    []
})
export class SimpleIconsSafariModule {}
